export const environment = {
    stage: 'dev',
    API_Base: "https://kiut-portal.wkld.dev.orf-4.at/api",
    backendGraphQLUrl: 'https://kiut-portal.wkld.dev.orf-4.at/api/graphql/',
    wsUrl: 'wss://kiut-portal.wkld.devs.orf-4.at/api/graphql/',
    cognitoAuthority: 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_GtxFUH0XV',
    cognitoClientId: '3ec7j7arnsbp5feibhcgbo3q99',
    cognitoLogoutUrl: 'https://orf-kiut-dev-login.auth.eu-central-1.amazoncognito.com/logout',
    transcribeWebrtcUrl: '/webrtc-api'
};
